import { Button } from '../types/generated';

export const buttonUrl = (button: Button) => {
	return button.fields.url || button.fields.page?.fields.path || '';
};
